import { AccountInfo, PublicClientApplication, SilentRequest } from '@azure/msal-browser';
import { authenticationClientProvider, msalConfig } from '@config';

import { loadedAppInsights } from '../appInsights/appInsights';

export class AuthService {
  appInsights;
  account: AccountInfo | null = null;
  msalApplication: PublicClientApplication | null = null;
  msalApplicationScope = {
    scopes: msalConfig.scopes,
  };
  tokenScopes = msalConfig.scopes;

  constructor() {
    this.appInsights = loadedAppInsights;
    this.msalApplication = authenticationClientProvider;
    const currentAccounts = this.msalApplication.getAllAccounts();
    const account = currentAccounts.length >= 1 ? currentAccounts[0] : null;
    if (currentAccounts.length > 1) {
      this.msalApplication.setActiveAccount(account);
    }
    if (account) {
      this.account = account;
    }
  }

  async componentDidMount() {
    if (this.msalApplication) {
      await this.msalApplication.initialize();
    }
  }

  async signIn() {
    this.msalApplication?.loginRedirect(this.msalApplicationScope);
  }

  async signOut() {
    if (!this.account) {
      // no cached login to signout
      return;
    }

    const logoutRequestPayload = {
      account: this.account,
    };

    if (this.msalApplication) {
      this.msalApplication.logout(logoutRequestPayload);
    }
  }

  async handlePageLoadEvent() {
    return this.msalApplication?.handleRedirectPromise().then((authResult: any) => {
      this.handleRedirectResponse(authResult);
    });
  }

  async handleRedirectResponse(authResult: { account: null } | null) {
    console.log('authResult', authResult);
    if (authResult !== null) {
      this.account = authResult.account;
    } else {
      const currentAccounts = this.msalApplication?.getAllAccounts(); // Add null check
      if (currentAccounts === undefined || currentAccounts === null) {
        return;
      } else if (currentAccounts?.length > 1) {
        console.warn(`more than one msal account found. Forcing to first ${currentAccounts[0]}`);
        this.account = currentAccounts[0];
      } else if (currentAccounts?.length === 1) {
        this.account = currentAccounts[0];
      }
    }
  }

  async getAccount() {
    const currentAccounts = this.msalApplication?.getAllAccounts(); // Add null check
    if (currentAccounts === undefined || currentAccounts === null) {
      this.signIn();
    } else if (currentAccounts.length > 1) {
      console.warn(`more than one msal account found. Forcing to first ${currentAccounts[0]}`);
      this.account = currentAccounts[0];
    } else if (currentAccounts.length === 1) {
      this.account = currentAccounts[0];
    }

    return this.account;
  }

  async getToken(forceRefresh = false) {
    const account = this.account ?? (await this.getAccount());
    if (account) {
      if (forceRefresh) {
        console.warn('token refresh requested');
      }
    } else {
      console.warn('no account found');
    }
    const tokenRequest: SilentRequest = {
      account: account ?? undefined,
      scopes: this.tokenScopes,
      forceRefresh: forceRefresh,
    };

    return this.msalApplication?.acquireTokenSilent(tokenRequest);
  }
}
const authConfigInstance = new AuthService();
export default authConfigInstance;
